module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/leading_primary_computing-8b3829c1abaa897f1ceab4828b3a2d36.jpeg";